import {
  AdvancedMarker,
  InfoWindow, Pin,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import {useEffect, useState} from "react";
import {getAssetPath} from "../../../utils/get-asset-path.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const MarkerWithInfoWindows = ({data, onClick, infoWindowContent, isOpen}) => {
  const [markerRef, marker] = useAdvancedMarkerRef();

  const svg = data?.marker
    ? getAssetPath(`img/markers/genericMarkers/${data.marker.trim()}`)
    : null;

  const customMarker = data?.custom_marker
    ? `${API_KEEPER}/ged/attach/${data.custom_marker}`
    : null

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        onClick={() => {
          onClick(data);
        }}
        position={{ lat: data.lat ?? data.latitude, lng: data.lng ?? data.longitude }}
      >
        {(svg) ? <img src={customMarker ? customMarker : svg} height={24} width={24}/> : null}
      </AdvancedMarker>
      {isOpen && marker && (
        <InfoWindow
          anchor={marker}
          minWidth={480}
          maxWidth={480}>
          {infoWindowContent}
        </InfoWindow>
      )}
    </>
  );
}

export default MarkerWithInfoWindows